<template>
  <div class="czzn-cpjs">
    <div class="cjwt-main-tit"><h2>通用问题：</h2></div>
    <div class="cjwt_main_con">
      <v-wd v-for="(item, index) in wdArr" :key="index" :wtda="item" ></v-wd>
    </div>
  </div>
</template>
<script>
import vWd from '../../components/wd.vue';

export default {
  name: 'cjwt_tywt',
  components: {
    vWd,
  },
  data() {
    return {
      wdArr: [
        {
          question: '新手快速上手指南',
          answer: '注册进入企业管理中心后，先选择新建账套，再增加用户并授权，然后进入账套后，根据公司的核算要求进行科目设置，并完善期初数据，试算平衡后，进行日常业务处理录入凭证，日常凭证完成后，直接查看账簿报表，无需记账操作，月末系统自动进行期末结转，进入下一个会计期间，已结账期间如需调整凭证，需取消结账后进行修改。同时平台还提供了报表一键报送功能。',
        },
        {
          question: '产品支持哪些浏览器？',
          answer: '目前，e记账支持谷歌Chrome浏览器、360浏览器（极速版）',
        },
        {
          question: '免费版本有什么限制？',
          answer: '免费版本在功能上与正式版本基本没区别，试用期限为30天。',
        },
        {
          question: '用户是什么意思？',
          answer: '用户就是指可以同时进入到一个账套操作的人员，例如，会计负责做凭证，主管负责审核凭证，老板还可以进行报表查看，这样就需要3个用户。',
        },
        {
          question: '如何保证财务数据安全？',
          answer: 'e记账为保护客户的数据安全，从技术、服务规范流程、安全认证、网络环境、法律等各个方面进行了细致而周密的设计，并严格执行，确保为您打造一个全方位的安全保障体系。 网站安全： 以用户数据高安全、可用为目的，采用完善、成熟的网络架构，严格的安全设计，对网络、关键应用采取了多级容灾、冗余方案。',
        },
      ],
    };
  },
};
</script>
